import { useEffect } from "react";
import { titleFromParams } from "../../Utilities/helperFunction";
import Location from "./location";

const GeoLocation = ({ mock, index, setMaintainValues, maintainValues, setValue, setScrollDisable }) => {
    return (
        <div className="linkedin-container">
            <div className="linkedin-title">
                <h1 className="title">
                    <span>
                        {index}
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="11"
                            height="10"
                            viewBox="0 0 24 24"
                        >
                            <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
                        </svg>
                    </span>
                    <div
                        dangerouslySetInnerHTML={{ __html: titleFromParams(mock?.title) }}
                    />
                </h1>
                <div>
                    <p>{mock?.description}</p>
                </div>
            </div>
            <Location
                mock={mock}
                setScrollDisable={setScrollDisable}
                name={mock?.name}
                maintainValues={maintainValues}
                setMaintainValues={setMaintainValues}
                setValue={setValue}
            />
        </div>
    );
};

export default GeoLocation;